module.exports = __webpack_public_path__ + "img/foodie-physician-cookbook_desktop.c0cf00a.jpg";